module.exports = __webpack_public_path__ + "files/ec99d21a6cb0b5fb95aad39bc00bd10d.png";